import { useEffect, useState } from 'react'

function DataGirdNonEditableCell ( props ) {
    const { field, idx, width, rowData, data, isRowNum } = props
    const [ rowIndex, setRowIndex ] = useState( rowData.indexOf( data ) )

    useEffect( () => {
        rowIndex > -1 && setRowIndex( rowIndex )
    }, [ rowIndex ] )

    return (
        <div
            key={ `${ field }${ idx }` }
            style={ {
                width: !isRowNum ? width : '50px',
                justifyContent : 'center',
                alignItems: 'center',
                display: 'flex',
            } }
        >
            { isRowNum ? rowIndex + 1 : data[ field ] || '' }
        </div>
    )
}

export default DataGirdNonEditableCell